export class QAccessFolder {
  constructor() {
    this.fFolderName = null;
    this.fFolderLocked = false;
  }

  InitFolder(folderName, locked) {
    this.fFolderName = folderName;
    this.fFolderLocked = locked;
  }

  GetFolderName() {
    return this.fFolderName;
  }

  IsLocked() {
    return this.fFolderLocked;
  }

  SetLocked(locked) {
    this.fFolderLocked = locked;
  }

  ToggleLock() {
    this.fFolderLocked = !this.fFolderLocked;
  }

  Clone() {
    var c = new QAccessFolder();
    c.InitFolder(this.fFolderName, this.fFolderLocked);
    return c;
  }
}
